const ImageWithOverlay = ({ src, title, subtitle }) => {
  return (
    <div className="relative group lg:w-2/5 aspect-[4/3] overflow-hidden">
      <img
        src={src}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        loading="eager"
        onLoad={(e) => {
          e.target.classList.remove('opacity-0');
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent pointer-events-none" />
      <div className="absolute bottom-0 left-0 right-0 z-20 p-4">
        <div className="bg-white/30 backdrop-blur-md border border-white/20 rounded-lg p-3 text-white">
          <h1 className="text-xl font-bold mb-1">{title}</h1>
          <p className="text-xs line-clamp-2">{subtitle}</p>
        </div>
      </div>
    </div>
  );
};

export default ImageWithOverlay;